import { createStore, applyMiddleware } from 'redux'
import reducers from './reducers';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';

import {gapiMiddleware} from './actions/gapi';
import config from './config';
import googleAnalytics from './middlewares/google-analytics';

const loggerMiddleware = createLogger();

export default createStore(
  reducers,
  config.debug
    ? applyMiddleware(
      thunkMiddleware,
      loggerMiddleware,
      gapiMiddleware,
      googleAnalytics
    )
    : applyMiddleware(
      thunkMiddleware,
      gapiMiddleware,
      googleAnalytics
    )
);


// WEBPACK FOOTER //
// ./src/store.js